module.exports = __webpack_public_path__ + "media/images/img_service_problem_1-5eb9cc520a40241e14513bcf24f01d03.jpg";